export default __webpack_public_path__ + "static/media/movement.335a4d02.svg";